import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  ForwardedRef,
} from "react";
import Select from "react-select";
import useLabelSetup from "../../Hooks/useLabelSetup";
import { LabelSetup } from "../../redux/labelSetup/labelSetupSlice";
import useInventory from "../../Hooks/useInventory";
import { getBarcodeVales } from "../../utils/commonUtils";

interface LabelOption {
  value: string;
  label: string;
}

interface IPrintBarcodeDropdownProps {
  selectedLabel: LabelOption;
  setSelectedLabel: (value: LabelOption) => void;
}

export interface PrintBarcodeDropdownRef {
  printBarcode: (labelId: string, selectedItem: any) => void;
}

const PrintBarcodeLabelDropdown = forwardRef<
  PrintBarcodeDropdownRef,
  IPrintBarcodeDropdownProps
>(({ setSelectedLabel, selectedLabel }, ref: ForwardedRef<PrintBarcodeDropdownRef>) => {
  const [searchText, setSearchText] = useState<string>("");
  const [printLabelId, setPrintLabelId] = useState<LabelSetup[]>([]);
  const { getLabelSetupAPI } = useLabelSetup();
  const { barcodePrintAPI } = useInventory();

  const getBarcodeLabels = () => {
    getLabelSetupAPI({ searchText }).then((res) => {
      const options = res?.map((option: any) => ({
        value: option.id,
        label: option.labelName,
      }));
      setPrintLabelId(options);

      if (options?.length > 0) {
        setSelectedLabel(options[0]);
      }
    });
  };

  const printBarcode = (labelId: string, selectedItem: any) => {
    const barcodeValues = getBarcodeVales(selectedItem);
    barcodePrintAPI({
      lableId: labelId,
      barcodeVales: barcodeValues,
    }).then((res: any) => {
      window.open(res, "_blank", "noopener,noreferrer");
    });
  };

  useImperativeHandle(ref, () => ({
    printBarcode,
  }));

  useEffect(() => {
    getBarcodeLabels();
  }, []);

  return (
    <div className="barcodes-list-wrapper invt-overview-info-box">
      <Select
        classNamePrefix="react-select"
        options={printLabelId}
        id="locationId"
        name="locationId"
        value={printLabelId?.find(
          (option: any) => selectedLabel?.value === option.value
        )}
        onChange={(option: any) => {
          setSelectedLabel(option);
        }}
        className="react-select-container"
      />
    </div>
  );
});

export default PrintBarcodeLabelDropdown;